export const secureFetch = async (url, options = {}) => {
  const token = localStorage.getItem("beercard_access_token");
  const email = localStorage.getItem("beercard_logged_in_email");

  if (!token) {
  console.warn("⚠️ No token found in localStorage");
  }
  if (!email) {
  console.warn("⚠️ No email found in localStorage");
  }

  const response = await fetch(url, {
    method: options.method || "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-user-email": email,
      ...(options.headers || {}),
    },
    body: options.body,
  });  

  // If the response is not OK, throw
  if (!response.ok) {
  const text = await response.text();

  // Redirect if unauthorized
  const isProtectedRoute = !url.includes("/clubs") && !url.includes("/teams");
  
  if ((response.status === 401 || response.status === 403) && isProtectedRoute) {
    console.warn("🔒 Token expired or invalid. Redirecting to home...");
    localStorage.removeItem("beercard_access_token");
    localStorage.removeItem("beercard_logged_in_email");
    const base = process.env.REACT_APP_BASENAME || "";
    window.location.href = base || "/";
    return;
  }

    throw new Error(`❌ ${response.status} ${response.statusText}: ${text}`);
  }

  if (response.status === 401) {
    // Token expired or invalid
    localStorage.clear();

    window.location.href = "/login?sessionExpired=true";
    return;
  }

  // Try parse JSON; fallback to raw text
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.includes("application/json")) {
    return await response.json();
  } else {
    return await response.text();
  }
};